import defaultConfigs from './default';

const AWS = {
  aws_project_region: 'eu-west-1',
  aws_cognito_identity_pool_id:
    'eu-west-1:331dfd39-8c0c-4b4a-bdd8-32c285e576e4',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_gu4VG9OCG',
  aws_user_pools_web_client_id: '6s7sqgnq910b4p5d1lkgl84rtu',
  oauth: {},
  aws_appsync_graphqlEndpoint:
    'https://ojqznfnn2fazpi7lzcvc2vnz34.appsync-api.eu-west-1.amazonaws.com/graphql',
  aws_appsync_region: 'eu-west-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cloud_logic_custom: [
    {
      name: 'userapi',
      endpoint: 'https://eyi37mvbu4.execute-api.eu-west-1.amazonaws.com/diakss',
      region: 'eu-west-1',
    },
  ],
  aws_user_files_s3_bucket: 'clinicardstorage144704-diakss',
  aws_user_files_s3_bucket_region: 'eu-west-1',
  Auth: {
    cookieStorage: {
      domain:
        process.env.NODE_ENV === 'production'
          ? 'diakonessenhuis.clinicards.app'
          : 'localhost',
      path: '/',
      expires: 1,
      secure: process.env.NODE_ENV === 'production',
    },
  },
};

const defaultCarepathCards = [];

export default {
  ...defaultConfigs,
  ENABLE_ARTICLES: true,
  ENABLE_CAREPATH: true,
  ENABLE_MEDICAL_PROFILE: true,
  ENABLE_MANAGEMENT: true,
  ENABLE_ACTIVATIONPERIOD_CAREPATHITEM: true,
  AWS,
  defaultCarepathCards,
};
